<template>
    <div class="zhuanshudingding">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box-cont1">
                <p class="title-box">工程行业面临的三大挑战</p>
                <!-- <p class="con-box">如何既能快速打造数字化办公运营平台满足业务发展需要，又能保障信息安全及业务生态之间的完美融合</p> -->
                <ul class="ul-box">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/1b067686-36b6-4029-bd71-b1642b85a624.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="pp1">工程项目账款无法进行实时的独立</p>
                        <p class="pp2">A集团一个项目，直到项目做完才知道此项目</p>
                        <p class="pp2">亏损100多万...</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/5074a6d3-6a4e-41d6-ab8a-52eecf218aae.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="pp1">工程进度把控度低</p>
                        <p class="pp2">安徽某公司负责人，每天需要打100多通电</p>
                        <p class="pp2">话，在几十个项目群中查看各项目负责人汇</p>
                        <p class="pp2">报的项目进度</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/d5cdcc00-930f-45d2-8ec1-b2026290e5a3.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="pp1">人工纸质管理合同档案，查找不便</p>
                        <p class="pp2">A公司张总说：“我每个月专门花两周时间去</p>
                        <p class="pp2">统计开票种类，税率税额，核查每个项目的</p>
                        <p class="pp2">收款情况。”</p>
                    </li>
                </ul>
            </div>
            <div class="box2-cont1">
                <p class="miderTitle">解决方案优势</p>
                <div class="line"></div>
                <p class="letter-title">实现工程项目的全过程管理：经营目标为导向、项目管理为核心、成本控制为重点、进度管理为主线</p>
                <ul class="box2-ul">
                    <li>
                        <p class="ps1">制度化</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">通过软件系统将公司制度落地</p>
                    </li>
                    <li>
                        <p class="ps1">流程化</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">能够将工作流程固定化，防止不按制度办事</p>
                    </li>
                    <li>
                        <p class="ps1">科学化</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">通过软件可以进行科学计算，节省大量精力</p>
                    </li>
                </ul>
                
            </div>
        </div>
        <div class="cont2">
            <p class="miderTitles">三大核心功能</p>
            <ul class="tuijian">
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/e6233567-ae89-437c-a54c-741a64db2e52.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">项目成本管理</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">所有成本投入、利润情况一目了然，系统分析具体费用类</p>
                        <p class="p-hexin">别的支出占比、成本超支的原因，便于管理者做出更合理</p>
                        <p class="p-hexin">的决策。</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/3534eaab-4e88-4461-b831-e25757f6b8fc.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">项目进度管理</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">项目进度实施把控，项目现场人员也可以借助进度表进行</p>
                        <p class="p-hexin">进度管理。</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="http://img601.yun300.cn/repository/image/7818eef9-d969-4ce0-afd7-5e593d48124a.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="title-hexin">项目合同管理</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">合同在线管理，随时随地可查询；开票信息和合同对应不</p>
                        <p class="p-hexin">容易出错；违约记录在案，一手掌控便于分析；合同到期</p>
                        <p class="p-hexin">提醒，合理安排续签事宜。</p>
                    </div>
                </li>
                
            </ul>
            <div class="sssdd"></div>
        </div>

        <div class="cont3s">
            <p class="miderTitles">全链路解决工程项目管理应用</p>
            <ul class="tuijian">
                <li>
                    <img src="http://img601.yun300.cn/repository/image/11d8b781-8610-4ee1-be49-21336d3ee631.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目基础</p>
                    <p class="lianlutitle">信息管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/23b475dd-9375-421c-ae4a-cb9251f5a37d.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目前期管理</p>
                    <p class="lianlutitle">商务管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/f41c1df6-9ae8-4c3d-a55a-60c8905483e0.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目招投标</p>
                    <p class="lianlutitle">管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/f555f852-cfb2-40c3-9352-f1e07341b41b.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目合同</p>
                    <p class="lianlutitle">管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/439c038b-93db-427e-921d-100e681b67fa.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目采购</p>
                    <p class="lianlutitle">管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/ec5a3517-811f-452d-a7ad-ca30e378a249.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目劳务</p>
                    <p class="lianlutitle">材料设备管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/ddc52af2-94b9-4fdd-9661-28d8d46ccf19.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目进度</p>
                    <p class="lianlutitle">管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/1be9f6f3-45ae-4082-bb0c-02389dcdb365.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目施工现场</p>
                    <p class="lianlutitle">管理</p>
                </li>
                <li>
                    <img src="http://img601.yun300.cn/repository/image/220ca6a8-8989-4832-9bad-ff7655988a2a.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    <p class="lianlutitle">项目成本</p>
                    <p class="lianlutitle">管理</p>
                </li>
                
            </ul>
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="sssdd"></div>
        </div>
    </div>
</template>
        
<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       }
   }
}
</script>
<style lang='less' scoped>
.zhuanshudingding{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/jjfa_gcgl_1920337.5@1x.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .cont1{
        width: 100%;
        .box-cont1{
            width: 80%;
            margin: 40px auto;
            background-color: rgba(255, 255, 255, 1);
           box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
            border-radius: 6px;
            padding: 40px 90px;
            padding-bottom: 20px;
            .title-box{
                font-size: 30px;
                color: #000;
                line-height: 40px;
                letter-spacing: 2px;
            }
            .con-box{
                font-size: 20px;
                line-height: 25px;
                color:#696969;
                margin-top: 20px;
            }
            .ul-box{
                width: 100%;
                margin-top: 43px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 30%;
                    text-align: center;
                    img{
                        width: 100%;
                        height: 250px;
                        
                    }
                    .pp1{
                        font-size:24px;
                        color:#000000;
                        text-align: center;
                        line-height: 45px;
                        font-weight: bold;
                        letter-spacing: 2px;
                        margin-top: 10px;
                    }
                    .pp2{
                        font-size:18px;
                        color:#808080;
                        text-align: center;
                        line-height: 30px;
                    }
                }
            }
        }
        .box2-cont1{
            width: 100%;
            .box2-ul{
                width: 80%;
                margin: 50px auto;
                display: flex;
                justify-content: space-between;
                li{
                    width: 31%;
                    padding: 50px;
                    background-image: url("https://img.alicdn.com/tfs/TB15Q3KDhD1gK0jSZFKXXcJrVXa-370-184.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    .ps1{
                        font-size: 25px;
                        font-weight: 100;
                        color: #fff;
                        text-align: center;
                        line-height: 40px;
                    }
                    .lin-yuanjiao{
                        width: 50px;
                        height: 3px;
                        border-radius: 6px;
                        background-color: #fff;
                        margin: 0 auto;
                        margin-bottom: 22px;
                        margin-top: 13px;
                    }
                    .ps2{
                        font-size: 18px;
                        color:#FFFFFF;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 1px;
                        margin-top: 5px;
                    }
                }
            }
        }
        
    }
    .cont2{
        width: 100%;
        background-color: #F7F7F7;
        .miderTitles{
            font-size: 35px;
            text-align: center;
            color: #000;
            line-height: 130px;
        }
        .tuijian{
            width: 80%;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
                width: 31%;
                background-color: #fff;
                transition: all 0.3s linear;
                padding-bottom: 20px;
                .top-hexin{
                    width: 100%;
                    padding: 40px;
                    background-color: rgba(237, 240, 246, 1);
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 60px;
                        height: 50px;
                        margin-top: 10px;
                    }
                    .title-hexin{
                        font-size: 20px;
                        color: #000;
                        line-height: 36px;
                        text-align: center;
                        margin-top: 15px;
                    }

                }
                .bottom-hexin{
                    width: 100%;
                    background-color: #fff;
                    padding: 30px;
                    .p-hexin{
                        font-size: 19px;
                        line-height: 28px;
                        color:#696969;
                        text-align: center;
                    }
                }
            }
            li:hover{
                box-shadow: 0px 0px 20px 15px rgb(0 0 0 / 10%);
            }
        }
        
        .sssdd{
            height: 40px;
        }
    }
}
.miderTitle{
    font-size: 35px;
    text-align: center;
    color: #000;
    line-height: 50px;
}
.line{
   width: 40px;
    height: 2px;
    background-color: rgba(0, 137, 255, 1);
    margin: 0 auto;
    margin-top: 12px;
 }
 .letter-title{
    font-size: 21px;
    text-align: center;
   color: #000;
    line-height: 30px;
     margin-top: 15px;
}
.cont3s{
    width: 100%;
    background-color: #fff!important;
    .miderTitles{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 130px;
    }
    .tuijian{
            width: 80%;
            margin: auto;
            overflow: hidden;
            li{
                width: 15.5%;
                padding-top: 10px;
                padding-bottom: 30px;
                background-color: rgba(245, 245, 245, 1);
                transition: all 0.3s linear;
                float: left;
                margin-right: 14px;
                margin-bottom: 20px;
                text-align: center;
                margin-left: 0.3%;
                img{
                    width: 70px;
                    height: 70px;
                    margin-top: 20px;
                }
                .lianlutitle{
                    font-size: 19px;
                    color: #000;
                    text-align: center;
                    letter-spacing: 1px;

                }
            }
    }
    .zhuanjia{
            width: 80%;
             background-color: rgba(245, 245, 245, 1);
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
        .sssdd{
            height: 40px;
        }
}
</style>